// Cookie part
// Function to get a cookie by name
function getCookie(name) {
    const value = `; ${decodeURIComponent(document.cookie)}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        const parsedValue = parts.pop().split(';').shift();
        return parsedValue === 'undefined' ? undefined : parsedValue;
    }
}

// Function to set a cookie
function setCookie(name, value, options = {}) {
    options = {
        path: '/',
        ...options
    };

    if (options.expires instanceof Date) {
        options.expires = options.expires.toUTCString();
    }

    let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

    for (let optionKey in options) {
        updatedCookie += '; ' + optionKey;
        let optionValue = options[optionKey];
        if (optionValue !== true) {
            updatedCookie += '=' + optionValue;
        }
    }

    //console.log('Setting cookie:', JSON.stringify(value));
    document.cookie = updatedCookie;
}

// Main part
document.addEventListener('DOMContentLoaded', function () {

    // Check if the current product is in the wishlist
    const productId = $("#wishlist").data("product-id");
    const productTitle = $("#wishlist").data("product-title");
    const productCollectionTitle = $(".product__collection").data("collection-title");
    const productURL = $("#wishlist").data("product-url");
    const productPrice = $("#wishlist").data("product-price");
    const productImg = $("#wishlist").data("product-img");
    // Create a div element with the ID "wishlist-drawer-container"
    var wishlistDrawerContainer = document.createElement('div');
    wishlistDrawerContainer.id = 'wishlist-drawer-container';
    wishlistDrawerContainer.classList.add('wishlist-drawer-container'); // Optional: Add a class for styling

    var wishlistedItems = document.querySelector('.wishlisted-items-drawer__section');

    // Append the wishlist drawer container to the main section
    if (wishlistedItems) {
        wishlistedItems.appendChild(wishlistDrawerContainer);
    } else {
        document.body.appendChild(wishlistDrawerContainer);
    }

    // Function to retrieve wishlist items from cookies
    function getWishlistItems() {
        const wishlistJSON = getCookie('wishlistItems');
        return wishlistJSON ? JSON.parse(wishlistJSON) : [];
    }

    // Function to render wishlist items using Flexbox
    function renderWishlistItemsDrawer() {
        const wishlistDrawerContainer = document.getElementById('wishlist-drawer-container');
        wishlistDrawerContainer.innerHTML = ''; // Clear previous content

        // Create a single heading for all wishlist items
        const wishlistDrawerHeading = document.createElement('h2');
        wishlistDrawerHeading.textContent = 'Product';
        wishlistDrawerContainer.appendChild(wishlistDrawerHeading);

        const wishlistItems = getWishlistItems();

        // Check if there are items in the wishlist
        if (wishlistItems.length > 0) {
            document.getElementById('wishlistToggle').classList.add('non-empty-wishlist');
            document.getElementById('wishlistToggleDrawer').classList.add('non-empty-wishlist');
            wishlistItems.forEach(function (item, index) {
                // Create a div for each wishlist item
                const wishlistDrawerItem = document.createElement('div');
                wishlistDrawerItem.classList.add('wishlist-drawer-item');

                // Create divs for image, details, price, link, and remove button
                const imageAndDetailsDiv = document.createElement('div');
                const priceDiv = document.createElement('div');
                const linkDiv = document.createElement('div');
                const removeDiv = document.createElement('div');

                imageAndDetailsDiv.classList.add('wishlist-drawer-image-details-div');
                priceDiv.classList.add('wishlist-drawer-price-div');
                linkDiv.classList.add('wishlist-drawer-link-div');
                removeDiv.classList.add('wishlist-drawer-remove-div');

                // Set content for each div
                //imageAndDetailsDiv.innerHTML = `<img src="${item.product_img}" alt="${item.product_title}"><div class="item-details"><p><strong>${item.collection_title}</strong></p><p>${item.product_title}</p></div>`;
                imageAndDetailsDiv.innerHTML = `<img src="${item.product_img}" alt="${item.product_title}"><div class="item-details"><p>${item.product_title}</p></div>`;

                priceDiv.textContent = item.product_price;

                linkDiv.innerHTML = `<a href="${item.product_URL}"><button class="wishlist-drawer-shop-now-button">Shop now</button></a>`;

                // Create a remove button and add an event listener to handle removal
                const removeButton = document.createElement('button');
                removeButton.textContent = 'Remove';
                removeButton.addEventListener('click', function () {
                    // Call the removeItem function to remove the item from cookies
                    removeItem(index);

                    if (wishlistDrawerItem.parentNode === wishlistDrawerContainer) {
                        // Remove the wishlist drawer item div from the container
                        wishlistDrawerContainer.removeChild(wishlistDrawerItem);
                    }
                });

                // Add the remove button to the remove div
                removeDiv.appendChild(removeButton);

                // Append each div to the wishlist drawer item div
                wishlistDrawerItem.appendChild(imageAndDetailsDiv);
                wishlistDrawerItem.appendChild(priceDiv);
                wishlistDrawerItem.appendChild(linkDiv);
                wishlistDrawerItem.appendChild(removeDiv);

                // Append the wishlist drawer item div to the container
                wishlistDrawerContainer.appendChild(wishlistDrawerItem);


            });
        } else {
            // Display a message when the wishlist drawer is empty
            wishlistDrawerContainer.innerHTML = '<h2 class="subtitle">Your wishlist is empty</h2>';
            document.getElementById('wishlistToggle').classList.remove('non-empty-wishlist');
            document.getElementById('wishlistToggleDrawer').classList.remove('non-empty-wishlist');
        }
    }

    // Function to update the wishlist counter
    function updateWishlistCounter() {
        const wishlistItems = getWishlistItems();
        const wishlistCounter = document.getElementById('wishlistCounter');
        if (wishlistCounter) {
            wishlistCounter.textContent = wishlistItems.length; // Update the counter with the number of wishlist items
        }
    }

    function removeItem(index) {
        // Retrieve wishlist items from cookies
        const wishlistItems = getWishlistItems();

        // Remove the item at the specified index
        wishlistItems.splice(index, 1);

        // Update cookies with the modified wishlist items
        setCookie('wishlistItems', JSON.stringify(wishlistItems));

        // Render the updated wishlist items
        renderWishlistItemsDrawer();

        // Refresh the addToWishlist button style
        refreshAddToWishlistButton();
    }

    // Load wishlist items from cookies when the page loads
    let wishlistItems = getWishlistItems();

    // Check if the current product is in the wishlist
    if (isInWishlist(productId, wishlistItems)) {
        // Set button style to indicate it's in the wishlist
        $('#addToWishlistBtn svg').css('filter', 'invert(54%) sepia(13%) saturate(1049%) hue-rotate(356deg) brightness(95%) contrast(83%)');
        $('#addToWishlistBtn span').text('Remove from wishlist').css('color', 'var(--color-gold)');
    }

    // Add event listener to the "Add to Wishlist" button
    $('#addToWishlistBtn').on('click', function () {
        // Check if the item is already in the wishlist
        if (isInWishlist(productId, wishlistItems)) {
            // Item is in the wishlist, so remove it
            removeFromWishlist(productId);

            // Reset button color to default
            $('#addToWishlistBtn svg').css('filter', 'none');

            $('#addToWishlistBtn span').text('Add to wishlist').css('color', '#a9a9a9');
        } else {
            // Item is not in the wishlist, so add it
            addToWishlistItem();

            $('#addToWishlistBtn span').text('Remove from wishlist').css('color', 'var(--color-gold)');
            // Change button color to indicate it's in the wishlist
            $('#addToWishlistBtn svg').css('filter', 'invert(54%) sepia(13%) saturate(1049%) hue-rotate(356deg) brightness(95%) contrast(83%)');
        }
    });

    function addToWishlistItem() {
        // Create wishlist item object
        const wishlistItem = {
            product_id: productId,
            collection_title: productCollectionTitle,
            product_title: productTitle,
            product_URL: productURL,
            product_price: productPrice,
            product_img: productImg,
            quantity: 1,
        };

        // Add the new item to the wishlist
        wishlistItems.push(wishlistItem);

        // Save the updated wishlist back to cookies
        setCookie('wishlistItems', JSON.stringify(wishlistItems));

        //console.log(JSON.stringify(wishlistItems));

        // Trigger the addToWishlist function
        addToWishlist();

        // Refresh the addToWishlist button style
        refreshAddToWishlistButton();
        updateWishlistCounter();
    }

    function addToWishlist() {
        // Display a notification element
        const notification = $('#notification');

        // Clear the content of the notification
        notification.empty();

        // Create an SVG element (change the content based on your SVG)
        const svgElement = $('<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 512 512"><path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z" fill="#FFFFFF"/></svg>');

        // Insert the SVG element before the text in the notification
        notification.append(svgElement);

        // Set the text for the notification
        notification.append(' Item added to wishlist!');

        // Display the notification
        notification.css('right', '0');

        setTimeout(() => {
            // Move the notification back to the right, hiding it
            notification.css('right', '-100%');
        }, 2000);

        // Refresh the wishlist drawer to reflect the updated items
        renderWishlistItemsDrawer();
    }

    function isInWishlist(productId, wishlistItems) {
        // Check if the product with the given productId is in the wishlist
        return wishlistItems.some(item => item.product_id === productId);
    }

    function refreshAddToWishlistButton() {
        // Load wishlist items from cookies
        wishlistItems = getWishlistItems();

        // Check if the current product is in the wishlist
        if (isInWishlist(productId, wishlistItems)) {
            // Set button style to indicate it's in the wishlist
            $('#addToWishlistBtn svg').css('filter', 'invert(54%) sepia(13%) saturate(1049%) hue-rotate(356deg) brightness(95%) contrast(83%)');
        } else {
            // Reset button color to default
            $('#addToWishlistBtn span').text('Add to wishlist').css('color', '#a9a9a9');
            $('#addToWishlistBtn svg').css('filter', 'none');
        }
    }

    function removeFromWishlist(productId) {
        // Remove the item with the given productId from the wishlist
        wishlistItems = wishlistItems.filter(item => item.product_id !== productId);

        // Update cookies with the modified wishlist items
        setCookie('wishlistItems', JSON.stringify(wishlistItems));

        //console.log(JSON.stringify(wishlistItems));

        // Refresh the wishlist drawer to reflect the updated items
        renderWishlistItemsDrawer();
        updateWishlistCounter();
    }

    // Call the render function on page load
    renderWishlistItemsDrawer();
});